import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setColumnReschedulingAction = (
  state: PlanboardState,
  action: PayloadAction<{ machineId: number; isRescheduling: boolean }>
) => {
  const { machineId, isRescheduling } = action.payload;
  if (isRescheduling) {
    if (!state.reschedulingMachineIds.includes(machineId)) {
      state.reschedulingMachineIds.push(machineId);
    }
  } else {
    state.reschedulingMachineIds = state.reschedulingMachineIds.filter((id) => id !== machineId);
  }
};
